export const ExtraSections = ({ sections = [] }) =>
  sections.map((s) => (
    <section key={s.key} className="bg-white py-20" data-testid={`extra-section-${s.key}`}>
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <h2 className="font-display text-3xl font-extrabold tracking-tight text-[#0B2545]">{s.title}</h2>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {s.items.map((it, i) => (
            <div key={i} className="rounded-2xl border border-slate-200 p-6">
              {it.image_url && <img src={it.image_url} alt={it.name} className="mb-4 aspect-square w-full rounded-xl object-cover" />}
              <h3 className="font-semibold text-[#0B2545]">{it.name}</h3>
              {it.description && <p className="mt-1 text-sm text-slate-500">{it.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  ));
